// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-components-Mc2ReadonlyCell-Mc2ReadonlyCell-module__text--DNFge {
  padding: 4px 10px;
  color: #555;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart2/Mc2Summary/Mc2Entity/Mc2Table/components/Mc2ReadonlyCell/Mc2ReadonlyCell.module.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,WAAA;EACA,cAAA;EAEA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAAF","sourcesContent":[".text {\n  padding: 4px 10px;\n  color: #555;\n  display: block;\n\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-components-Mc2ReadonlyCell-Mc2ReadonlyCell-module__text--DNFge`
};
export default ___CSS_LOADER_EXPORT___;
